<template>
  <div id="autenticidadeQr" v-if="licencaPesca">
    <h2
      class="title-autenticidadeQr"
      :class="{ 'not-informed': exist(licencaPesca.licenca.emissao) }"
    >
      {{ tituloInicial() }}
    </h2>
    <card class="dadosPessoais">
      <h3 class="title">
        {{ $t(`${autenticidadeQr_prefix}titulo.dadosPessoais`) }}
      </h3>
      <div class="flex">
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.nome`) }}
          </h4>
          <h4
            class="informacoes"
            :class="{ 'not-informed': exist(pessoa && pessoa.nomeRazaoSocial) }"
          >
            {{
              (pessoa && pessoa.nomeRazaoSocial)
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.cpf`) }}
          </h4>
          <h4
            class="informacoes"
            :class="{
              'not-informed': exist(pessoa && pessoa.cpfCnpjPassaporteFormatado)
            }"
          >
            {{
              (pessoa && pessoa.cpfCnpjPassaporteFormatado)
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
      </div>
    </card>
    <card class="dadosLicenca">
      <h3 class="title">
        {{ $t(`${autenticidadeQr_prefix}titulo.dadosLicenca`) }}
      </h3>
      <div class="flex">
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.numeroLicenca`) }}
          </h4>
          <h4
            class="informacoes"
            :class="{ 'not-informed': exist(licencaPesca.licenca.codigo) }"
          >
            {{
              licencaPesca.protocolo.codigoFormatado
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.modalidade`) }}
          </h4>
          <h4
            class="informacoes"
            :class="{ 'not-informed': exist(licencaPesca.licenca.modalidade) }"
          >
            {{
              modalidade()
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.emissao`) }}
          </h4>
          <h4
            class="informacoes"
            :class="{
              'not-informed': exist(licencaPesca.licenca.dataEmissaoExibicao)
            }"
          >
            {{
              licencaPesca.licenca.dataEmissaoExibicao
                | placeholder($t(`${autenticidadeQr_prefix}hifem`))
            }}
          </h4>
        </div>
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.validade`) }}
          </h4>
          <h4
            class="informacoes"
            :class="{
              'not-informed': exist(licencaPesca.licenca.dataValidadeExibicao)
            }"
          >
            {{
              licencaPesca.licenca.dataValidadeExibicao
                | placeholder($t(`${autenticidadeQr_prefix}hifem`))
            }}
          </h4>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <h4 class="status">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.situacao`) }}
          </h4>
          <div>
            <status-badge :status="licencaPesca.licenca.status.descricao" />
          </div>
        </div>
      </div>
    </card>
    <card class="dadosEndereco">
      <h3 class="title">
        {{ $t(`${autenticidadeQr_prefix}titulo.enderecoPrincipal`) }}
      </h3>
      <div class="flex">
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.endereco`) }}
          </h4>
          <h4 class="informacoes" :class="{ 'not-informed': exist(endereco) }">
            {{
              enderecoLinha
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.municipio`) }}
          </h4>
          <h4 class="informacoes" :class="{ 'not-informed': exist(endereco) }">
            {{
              municipioUfLinha
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.cep`) }}
          </h4>
          <h4
            class="informacoes"
            :class="{ 'not-informed': exist(endereco && endereco.cep) }"
          >
            {{
              (endereco && endereco.cep)
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
        <div class="flex-item">
          <h4 class="align">
            {{ $t(`${autenticidadeQr_prefix}titulo.label.pais`) }}
          </h4>
          <h4 class="informacoes" :class="{ 'not-informed': exist(nomePais) }">
            {{
              nomePais
                | placeholder($t(`${autenticidadeQr_prefix}naoInformado`))
            }}
          </h4>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Card from "../layouts/Card";
import { INTERFACE_AUTENTICIDADE_PREFIX } from "../../utils/messages/interface/registrar/autenticidadeQr/autenticidadeQr";
import { translate } from "../../utils/helpers/internationalization";
import { FETCH_DADOS_CARTEIRA } from "../../store/actions.type";
import _ from "lodash";
import StatusBadge from "../shared/StatusBadge.vue";

export default {
  name: "buscar",

  components: {
    Card,
    StatusBadge
  },

  data() {
    return {
      autenticidadeQr_prefix: INTERFACE_AUTENTICIDADE_PREFIX
    };
  },

  computed: {
    ...mapGetters(["licencaPesca"]),
    pessoa() {
      return (this.licencaPesca && this.licencaPesca.pessoa) || null;
    },
    endereco() {
      return this.pessoa && this.pessoa.endereco;
    },
    enderecoLinha() {
      const e = this.endereco;
      if (!e) return null;
      const num =
        e.numero != null && String(e.numero).trim() !== ""
          ? ", Nº " + e.numero
          : "";
      const compl = e.complemento ? ", " + e.complemento : "";
      const bairro = e.bairro ? ", " + e.bairro : "";
      const linha = (e.logradouro || "") + num + compl + bairro;
      return linha.trim() ? linha : null;
    },
    municipioUfLinha() {
      const e = this.endereco;
      if (!e || !e.municipio) return null;
      const m = e.municipio;
      const uf =
        m.estado && m.estado.sigla
          ? "/" + m.estado.sigla
          : m.estado && m.estado.nome
          ? "/" + m.estado.nome
          : "";
      const s = (m.nome || "") + uf;
      return s || null;
    },
    nomePais() {
      const pa = this.endereco && this.endereco.pais;
      if (!pa) return null;
      return pa.nomePt;
    }
  },

  methods: {
    fetchData() {
      this.$store.dispatch(FETCH_DADOS_CARTEIRA, this.$route.params.protocolo);
    },
    exist(attr) {
      return attr === null || _.isNil(attr);
    },
    modalidade() {
      if (this.licencaPesca.licenca.modalidade === "RECREATIVA") {
        return translate(
          `${this.autenticidadeQr_prefix}titulo.modalidades.recreativa`
        );
      }
      return translate(
        `${this.autenticidadeQr_prefix}titulo.modalidades.esportiva`
      );
    },
    tituloInicial() {
      if (
        this.licencaPesca.licenca.status.codigo == "ATIVO_AGUARDANDO_PAGAMENTO"
      ) {
        return translate(
          `${this.autenticidadeQr_prefix}titulo.tituloInicialProvisoria`
        );
      }
      return translate(`${this.autenticidadeQr_prefix}titulo.tituloInicial`);
    }
  },

  created() {
    this.fetchData();
  }
};
</script>

<style lang="sass">
@import "../../theme/tools/variables"

#autenticidadeQr
  h1
    font-weight: 500

  .label-search
    margin-top: 30px

  .el-steps
    height: 30px

  .title
    font-weight: bold
    font-size: 18px

  .title-autenticidadeQr
      text-align: center
      font-weight: bold
      font-size: 30px

  .align
    display: flex
    flex-direction: column
    padding-top: 20px
    font-weight: bold

  .status
      padding-bottom: 4px;
      display: flex
      flex-direction: column
      padding-top: 20px
      font-weight: bold

  .informacoes
      font-weight: normal
      margin: 5px 0

  .footer-card
    margin-top: 30px
    border-top: $--cor-borda 1px solid
    padding-top: 20px
    display: flex
    align-items: center
    justify-content: space-between

    .footer-label
      font-size: $--fonte-pequena
      color: $--cor-texto-secundario

  .flex
      display: flex

      .flex-item
          flex: 1
          display: grid

  @media screen and (max-width: 600px)
      .flex
          display: flex
          flex-flow:  column-reverse

          .flex-item
              flex: 1
              display: grid
</style>
